import { useContext } from 'react'

import { QuestionnaireEngineContext } from '../providers/QuestionnaireEngineProvider'

import type { QuestionnaireEngineContextType } from '../types/questionnaire-engine.types'

export const useQuestionnaireEngine = () => {
  const context = useContext<QuestionnaireEngineContextType>(QuestionnaireEngineContext)
  if (!context) throw new Error('Must wrap in <QuestionnaireEngineProvider>')
  return context
}
